import { stringify } from "querystring";
import ApiService from "./ApiService";
import { format } from "util";

const ENDPOINTS = {
  GET_CONTACT_NOTES: "contacts/%s/notes/?page=%s&perPage=%s&group=%s&search=%s",
  NOTES_ITEM: "contacts/%s/notes/",
  SINGLE_NOTE: "contacts/%s/notes/%s/",
  GROUPED_NOTES: "contacts/%s/notes/grouped/",
  APPOINTMENT_COMMENTS: "contacts/%s/notes/",
  UPDATE_APPOINTMENT_COMMENT:
    "contacts/%s/notes/%s/update_appointment_comment/",
};

class NoteService extends ApiService {
  getContactNotesByPage = (page, perPage, id, group, search) => {
    return this.apiClient.get(
      format(ENDPOINTS.GET_CONTACT_NOTES, id, page, perPage, group, search),
    );
  };

  postNewNote = ({ id, data }) => {
    return this.apiClient.post(format(ENDPOINTS.NOTES_ITEM, id), data);
  };

  deleteNote = ({ contactId, id }) => {
    return this.apiClient.delete(format(ENDPOINTS.SINGLE_NOTE, contactId, id));
  };
  updateNote = ({ contactId, id, data }) => {
    return this.apiClient.put(
      format(ENDPOINTS.SINGLE_NOTE, contactId, id),
      data,
    );
  };
  getGroupedNotes = (id) => {
    return this.apiClient.get(format(ENDPOINTS.GROUPED_NOTES, id));
  };

  getAppointmentComments = (payload) => {
    const { contactId, ...query } = payload;
    return this.apiClient.get(
      `${format(ENDPOINTS.APPOINTMENT_COMMENTS, contactId)}?${stringify(query)}`,
    );
  };

  updateAppointmentComment = ({ contactId, noteId, data }) => {
    return this.apiClient.patch(
      format(ENDPOINTS.UPDATE_APPOINTMENT_COMMENT, contactId, noteId),
      data,
    );
  };
}

export default new NoteService();
